// import PropTypes from 'prop-types'
import { useRef, useState } from 'react'

import {
  Root,
  Main,
  VideoWrapper,
  Text,
  PlayButton,
  LogoWrapper,
  LogosWrapper,
  SoundControls,
} from './Introduction.style'

import Logo from './logo.svg'
import Logos from './logos.svg'
import Play from './play.svg'
import SoundOff from './sound-off.svg'
import SoundOn from './sound-on.svg'

const Introduction = () => {
  const videoEl = useRef(null)
  const [muted, setMuted] = useState(true)

  const handleSouncControlClick = () => {
    if (muted) {
      videoEl.current.muted = false
    } else {
      videoEl.current.muted = true
    }

    setMuted(!muted)
  }

  return (
    <Root>
      <VideoWrapper>
        <video autoPlay muted loop playsInline ref={videoEl}>             
          <source
            src="https://res.cloudinary.com/the-armoury/video/upload/vc_auto/v1642529909/H.Moser-Armoury-full_light_w1cmrb.webm"
            type="video/webm"
          />
          <source
            src="https://res.cloudinary.com/the-armoury/video/upload/vc_auto/v1642529909/H.Moser-Armoury-full_light_w1cmrb.mp4"
            type="video/mp4"
          />
          <source
            src="https://res.cloudinary.com/the-armoury/video/upload/vc_auto/v1642529909/H.Moser-Armoury-full_light_w1cmrb.ogv"
            type="video/ogg"
          />
        </video>
        <PlayButton>
          <Play />
        </PlayButton>
        <SoundControls onClick={handleSouncControlClick}>{muted ? <SoundOff /> : <SoundOn />}</SoundControls>
      </VideoWrapper>
      <Main>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <LogosWrapper>
          <Logos />
        </LogosWrapper>
        <Text>
          <p>
            The Armoury in collaboration with <span className="whitespace-nowrap">H Moser &amp; Cie.</span> has created
            the <span className="whitespace-nowrap">TOTAL ECLIPSE</span>, a limited edition watch based on{' '}
            <span className="whitespace-nowrap">H Moser’s</span> Endeavour Small Seconds and inspired by the celestial
            event of a Total Solar Eclipse.
          </p>
        </Text>
      </Main>
    </Root>
  )
}

Introduction.propTypes = {}

Introduction.defaultProps = {}

export default Introduction
